// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"754":"0988447a","933":"01261a31"}[chunkId] + ".chunk.css";
};